import axios from 'axios';
import {
    AddToolManagerCommand,
    RemoveToolManagerCommand,
    ToolManagerDto,
} from './models/ToolManagerDto';

export const getToolManagers = async (toolId: string): Promise<ToolManagerDto[]> => {
    const { data } = await axios.get<ToolManagerDto[]>(
        `${window.configuration.apiUrl}api/Tools/${toolId}/managers`,
    );

    return data;
};

export const getToolOwnerTools = async (): Promise<string[]> => {
    const { data } = await axios.get<string[]>(`${window.configuration.apiUrl}api/Tools/owner/me`);

    return data;
};

export const addToolManager = async (command: AddToolManagerCommand): Promise<boolean> => {
    await axios.post(`${window.configuration.apiUrl}api/Tools/${command.toolId}/managers`, command);

    return true;
};

export const removeToolManager = async (command: RemoveToolManagerCommand): Promise<boolean> => {
    await axios.delete(`${window.configuration.apiUrl}api/Tools/${command.toolId}/managers`, {
        data: command,
    });

    return true;
};
